import { createVNode as i, mergeProps as n } from "vue";
import o from "../node_modules/@pf-ui/pf-icon-svg/es/asn/ApiManageFilledStandard.js";
import d from "../components/PfIcon.js";
const a = (r, e) => {
  const t = {
    ...r,
    ...e.attrs
  };
  return i(d, n(t, {
    icon: o
  }), null);
};
a.displayName = "ApiManageFilledStandard";
a.inheritAttrs = !1;
export {
  a as default
};
